
import {Injectable } from "@angular/core";

import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";

import { Observable, throwError } from "rxjs";

import { catchError } from "rxjs/operators";

import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor{
    constructor(private router : Router){}


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        return next.handle(req).pipe(
            catchError(
                (error : HttpErrorResponse)=>{
                    if (error.status === 401 && this.router.url !== '/') {
                        this.router.navigate(['/'])
                    }

                    return throwError(error);
                })
        );
    }
}

